<template lang="pug">
  router-link.logo-container(:to='{name:"home"}')
    .image-container
      img(:src='"@/assets/logo-"+this.$store.state.theme+".svg"')
    .text-container
      .line Automated
      .line Hirschberg
</template>

<script>
export default {

}
</script>

<style scoped lang="sass">
@import ../sass/variables

.logo-container
  display: flex
  text-decoration: none
  justify-content: center
  align-items: center
  margin: auto

  .image-container
    padding-top: 0.2em
    img
      height: $logo-height

  .text-container
    padding-left: 0.8em
    font-family: $font-display
    color: var(--fg1)
    font-size: $font-size-1
    line-height: 1em
</style>
